import React from 'react';
import { resolveMediaUrl } from '../../../utility/media';
// import closeButton from '../../assets/images/close.png';
import { IoClose } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';

const ViewRtiAlertDetailsModal = ({ data, onClose }) => {
    const { t } = useTranslation();

    // The component uses 'data' prop from your Page, but I've mapped it 
    // to match your reference layout logic
    if (!data) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                
                {/* Modal Header matches image_0ca234.png */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('rti.rtiDetails') || 'RTI Details'}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose size={22} />
                    </button>
                </div>

                <div className="staff-form-body bg-white px-8 py-6" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    
                    {/* RTI Information Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-3 mb-8">
                        <InfoRow label={t('complaint.complainerName') || 'Complainer Name'} value={data.complainerName} />
                        <InfoRow label={t('rti.rtiAgainst') || 'RTI Against'} value={data.rtiAgainst} />

                        {/* Full Width Row for Details */}
                        <div className="col-span-2 flex items-start text-sm">
                            <label className="w-44 font-bold text-gray-600 text-right">
                                {t('rti.rtiDetails') || 'RTI Details'} (*)
                            </label>
                            <span className="px-3 font-bold text-gray-800">:</span>
                            <div className="flex-1 font-bold text-gray-800 whitespace-pre-wrap">
                                {data.rtiDetails}
                            </div>
                        </div>

                        <InfoRow label={t('rti.rtiDate') || 'RTI Date'} value={data.rtiDate} />
                        <InfoRow label={t('attendance.department') || 'Department'} value={data.departmentName} />
                    </div>

                    {/* Attachments Table */}
                    <div className="overflow-hidden border border-gray-400 rounded-sm">
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-gray-400">
                                    <th className="p-2 text-center border-r border-gray-400 font-bold w-12">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-gray-400 font-bold text-center">{t('common.description')}</th>
                                    <th className="p-2 text-center font-bold w-64">{t('common.attachments')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.attachmentData && data.attachmentData.length > 0 ? (
                                    data.attachmentData.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-gray-400 last:border-0">
                                            <td className="p-2 text-center border-r border-gray-400">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-gray-400 font-medium">
                                                {item.description || "N/A"}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.fileUrl ? (
                                                    <a
                                                        href={resolveMediaUrl(item.fileUrl)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800 break-all font-bold"
                                                    >
                                                        {item.fileName || t('common.view')}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">{t('forms.common.noFile') || 'No File'}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            {t('common.noRecords') || 'No Records Found'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Section */}
                <div className="staff-form-footer p-4 flex justify-center border-t bg-gray-50 rounded-b-2xl">
                    <button
                        className="staff-btn-save"
                        style={{ background: '#7a89d2' }} // Matching the blue-ish tone of your buttons
                        onClick={onClose}
                    >
                        {t('common.close') || 'Close'}
                    </button>
                </div>
            </div>
        </div>
    );
};

// Helper for row design to maintain consistency
const InfoRow = ({ label, value }) => (
    <div className="flex items-center text-sm">
        <label className="w-44 font-bold text-gray-600 text-right">{label}</label>
        <span className="px-3 font-bold text-gray-800">:</span>
        <span className="flex-1 font-bold text-gray-800">{value || "N/A"}</span>
    </div>
);

export default ViewRtiAlertDetailsModal;